export function renderText(testoHTML) {
  if (!testoHTML) return "";
  const strippedText = testoHTML.replace(/<[^>]*>/g, "");
  const truncatedText =
    strippedText.length > 230
      ? strippedText.substring(0, 230) + "..."
      : strippedText;
  return <div>{truncatedText}</div>;
}
